import React, { Fragment } from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../../src/web/components/utils';
import { useNavigate, useLocation } from 'react-router-dom';
import { storeState } from '../../../store/hooks';
const Breadcrumb: React.FC = React.memo((): JSX.Element => {
    let navigate = useNavigate();
    const { pathname } = useLocation();
    const crumbs = storeState((state: any) => state.app.crumbs);
    const CRUMB_EXCLUSION = ['/','/dashboard', '/companyadmin/dashboard', '/patient/patientdashboard', '/admin/admindashboard'];

    return (
        <Fragment>
            {
                crumbs && !CRUMB_EXCLUSION.includes(pathname) &&
                <div className="page-header">
                    {
                        crumbs.map((crumb: any, index: number) => {
                            return (
                                <div className="row" key={index}>
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item"><a onClick={() => navigate(`${crumb.path}`)}>Home </a></li>
                                            <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                                            <li className="breadcrumb-item active">{crumb.name}</li>
                                        </ul>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }
        </Fragment>
    );
});

export default Breadcrumb;